import eventBus, {
  CustomEventMap,
  EventBusSubscription,
} from "@sd-utility/eventbus";
import { useEffect } from "react";
import { Subscription } from "rxjs";

export const useEventBus = (
  eventName: keyof CustomEventMap,
  callback: () => void,
) => {
  useEffect(() => {
    let shopdirectSubscription: Subscription;
    let eventBusSubscription: EventBusSubscription;
    if (window.shopdirect?.event) {
      shopdirectSubscription = window.shopdirect.event.subscribe(
        eventName,
        callback,
      );
    }
    if (eventBus) {
      eventBusSubscription = eventBus.subscribe(eventName, () => {
        callback();
      });
    }
    return () => {
      if (shopdirectSubscription) {
        shopdirectSubscription.unsubscribe();
      }
      if (eventBusSubscription) {
        eventBusSubscription.unsubscribe();
      }
    };
  }, [callback, eventName]);
};
